export default {
  methods: {
    showSimpleMessage(title) {
      return this.$dialog.alert(title, {
        okText: 'Ok',
        view: 'simple-dialog',
      });
    },
  }
}
